// extracted by mini-css-extract-plugin
module.exports = {"partners":"_3qPMn","partnerSelectionPanelWrapper":"Hdnqe","partnerSelectionPanelCount":"_377AQ"};